<template>
  <div>
    <div class="table-responsive">
       <vs-table
        v-if="userAccount === 'betagrodemo' || admin == 'betagrodemo'"
        search
        :data="actionList"
        vs-lg="12"
        vs-sm="4"
        vs-xs="12"
        style="background-color: #ffffff; border-radius: 20px"
      >
        <template slot="thead">
          <vs-th  style="background: #484848; color: #ffffff" id="noWrap"> </vs-th>
          <vs-th  style="background: #484848; color: #ffffff" :key="item" sort-key="name"
            ><vs-row>
              <vs-col
                id="noWrap"
                vs-type="flex"
                vs-justify="center"
                vs-align="center"
              >
                Switch ON/OFF
              </vs-col>
            </vs-row>
          </vs-th>

          <vs-th  style="background: #484848; color: #ffffff" v-for="item in header" :key="item" sort-key="name" id="noWrap">
            {{ item }}
            <span><vs-icon icon="unfold_more" size="13px"></vs-icon></span>
          </vs-th>
        </template>
        <template slot-scope="{ data }">
          <tr  style="background: #212121; color: #ffffff" v-for="(item, i) in data" :key="item.id">
            <vs-td style="width: 220px" :data="item.active">
              <!-- <vs-td  style="width: 250px" :data="item.active"> -->
              <vs-button
                color="warning"
                type="flat"
                icon="create"
                @click="edit(item)"
                >Edit</vs-button
              >
              <vs-button
                color="danger"
                type="flat"
                icon="delete"
                v-b-modal.modal-center
                @click="id = item.id"
                >Delete</vs-button
              >
            </vs-td>
            <td>
              <vs-row>
                <vs-col vs-type="flex" vs-justify="center" vs-align="center">
                  <vs-switch
                    v-model="switcharray[i]"
                    @click="switch1(switcharray[i], i)"
                  >
                    <span slot="on">On</span>
                    <span slot="off">Off</span>
                  </vs-switch>
                </vs-col></vs-row
              >
            </td>
            <td>{{ item.name }}</td>
            <td>
              <span v-for="(condition, index) in item.con" :key="index">
                {{condition.senname.name }}&nbsp;{{ condition.param }}&nbsp;{{ !!(condition.con) ? condition.con+' ' : ''}}:&nbsp;{{ condition.param == 'Uninstalled' ? condition.value == 1 ? 'Install' : 'Uninstall' : condition.param == 'Unlocked' ? condition.value == 1 ? 'Lock' : 'Unlock' : condition.value }}
              </span>
            </td>
            <td>
              <span v-for="(action, index) in item.action" :key="index">
                {{ action.name }}:&nbsp;{{ action.detail }}:&nbsp;{{
                  action.status
                }}
              </span>
            </td>
            <td>
              <span
                v-if="item.active"
                class="
                  font-weight-normal
                  text-light
                  badge
                  badgeSuccess
                  badge-pill
                  px-2
                  py-1
                "
              >
                Active</span
              >
              <span
                v-else
                class="
                  font-weight-normal
                  text-light
                  badge
                  badgeGray
                  badge-pill
                  px-2
                  py-1
                "
              >
                Deactive
              </span>
            </td>
          </tr>
        </template>
      </vs-table>
      <vs-table
      v-else
        search
        :data="actionList"
        vs-lg="12"
        vs-sm="4"
        vs-xs="12"
        style="background-color: #ffffff; border-radius: 20px"
      >
        <template slot="thead">
          <vs-th id="noWrap"> </vs-th>
          <vs-th :key="item" sort-key="name"
            ><vs-row>
              <vs-col
                id="noWrap"
                vs-type="flex"
                vs-justify="center"
                vs-align="center"
              >
                Switch ON/OFF
              </vs-col>
            </vs-row>
          </vs-th>

          <vs-th v-for="item in header" :key="item" sort-key="name" id="noWrap">
            {{ item }}
            <span><vs-icon icon="unfold_more" size="13px"></vs-icon></span>
          </vs-th>
        </template>
        <template slot-scope="{ data }">
          <tr v-for="(item, i) in data" :key="item.id">
            <vs-td style="width: 220px" :data="item.active">
              <!-- <vs-td  style="width: 250px" :data="item.active"> -->
              <vs-button
                color="primary"
                type="flat"
                icon="add_circle"
                @click="link2(item)"
                >View</vs-button
              >
              <vs-button
                color="warning"
                type="flat"
                icon="create"
                @click="edit(item)"
                >Edit</vs-button
              >
              <vs-button
                color="danger"
                type="flat"
                icon="delete"
                v-b-modal.modal-center
                @click="id = item.id"
                >Delete</vs-button
              >
            </vs-td>
            <td>
              <vs-row>
                <vs-col vs-type="flex" vs-justify="center" vs-align="center">
                  <vs-switch
                    v-model="switcharray[i]"
                    @click="switch1(switcharray[i], i)"
                  >
                    <span slot="on">On</span>
                    <span slot="off">Off</span>
                  </vs-switch>
                </vs-col></vs-row
              >
            </td>
            <td>{{ item.name }}</td>
            <td>
              <span v-for="(condition, index) in item.con" :key="index">
                {{ condition.con }}:&nbsp;{{ condition.value }}
              </span>
            </td>
            <td>
              <span v-for="(action, index) in item.action" :key="index">
                {{ action.name }}:&nbsp;{{ action.detail }}:&nbsp;{{
                  action.status
                }}
              </span>
            </td>
            <td>
              <span
                v-if="item.active"
                class="
                  font-weight-normal
                  text-light
                  badge
                  badgeSuccess
                  badge-pill
                  px-2
                  py-1
                "
              >
                Active</span
              >
              <span
                v-else
                class="
                  font-weight-normal
                  text-light
                  badge
                  badgeGray
                  badge-pill
                  px-2
                  py-1
                "
              >
                Deactive
              </span>
            </td>
          </tr>
        </template>
      </vs-table>
    </div>
    <b-modal id="modal-center" centered>
      <template #modal-title>
        <b class="text-danger">
          <vs-icon icon="delete" size="small" color="red"></vs-icon>Delete
          Alert</b
        >
      </template>
      <p class="my-4">Do you want to delete alert?</p>

      <template #modal-footer="{ cancel }">
        <!-- Button with custom close trigger value -->
        <b-button id="btncancel" variant="light" @click="cancel()">
          Cancel
        </b-button>
        <vs-button
          color="danger"
          style="border-radius: 20px"
          size="sm"
          @click="del()"
          type="filled"
          >Delete</vs-button
        >
      </template>
    </b-modal>
  </div>
</template>
<script>
export default {
  name: "actionlist",
  props: ["actionList"],
  watch: {
    switcharray(value) {
      // console.log(value,value.indexOf(value))
    },
  },
  data: () => ({
    userAccount: "",
    admin: "",
    nwlist: [],
    header: ["Alert Name", "Condition", "Action", "Active Status"],
    sensorlist: [],
    action: [],
    editaction: {
      name: "",
      con: "",
      type: "",
      sensors: "",
      id: "",
      active: false,
    },
    realaction: [],
    switcharray: [],
    id: "",
  }),
  methods: {
    switch1(bool, i) {
      this.$vs.loading();
      this.action[i].active = !bool;
      this.$API
        .post("activeaction", {
          active: !bool,
          id: this.action[i].id,
        })
        .then(() => {
          this.$vs.notify({
            title: "Update Action",
            text: "Complete!",
            color: "success",
            position: "top-center",
            icon: "check",
          });
          setTimeout(() => {
            this.$vs.loading.close();
          }, 100);
        });
    },
    del() {
      this.$API
        .post("actiondel", {
          id: this.id,
        })
        .then(() => {
          this.$vs.notify({
            title: "Delete Action",
            text: "Complete!",
            color: "danger",
            position: "top-center",
            icon: "check",
          });
          setTimeout(() => {
            location.reload();
          }, 500);
        });
      this.$bvModal.hide("modal-center");
    },
    edit(item) {
      this.$session.set("action", "edit");
      this.$session.set("actiondetail", item);
      this.$router.push({
        name: "CreateAction",
      });
    },
    link2(item) {
      this.$session.set("action", "edit");
      this.$session.set("actiondetail", item);
      this.$router.push({
        name: "CreateAction",
      });
    },
    editactionsent() {
      var temp = [];
      temp = this.editaction.sensors.split(", ");
      // eslint-disable-next-line no-console
      // // console.log(temp)
      this.$API
        .post("updateaction", {
          name: this.editaction.name,
          con: this.editaction.con,
          type: this.editaction.type,
          sensors: temp,
          id: this.editaction.id,
          active: this.editaction.active,
          token: this.$session.get("token"),
        })
        .then(() => {
          this.$vs.notify({
            title: "Update Action",
            text: "Complete!",
            color: "success",
            position: "top-center",
            icon: "check",
          });
        });
    },
  },
  created() {
    this.userAccount = this.$session.get("username");
    this.admin = this.$session.get("admin")
    var temp = [];
    this.action = this.actionList;
    this.action.forEach((element, j) => {
      this.switcharray[j] = element.active;
      element.con.forEach((consen, i) => {
        this.sensorlist.forEach((sensor) => {
          if (sensor.id == consen.sensid) {
            consen.sensid = sensor.name;
          }
        });
      });
      element.action.forEach((action, i) => {
        console.log(action);
        if (
          (action.detail != "" && action.detail != null) ||
          (action.status != null && action.status != "")
        ) {
          if (action.name == "Work Order")
            temp.push({
              name: "Work Order",
              detail: action.detail.formConfig.headline,
            });
          else if (action.name == "Control" && status)
            temp.push({
              name: "Control",
              detail: action.detail,
              status: "OFF -> ON",
            });
          else if (action.name == "Control" && !status)
            temp.push({
              name: "Control",
              detail: action.detail,
              status: "ON -> OFF",
            });
          else temp.push(action);
        }
      });
      this.$API.get("sensors/user").then((result) => {
        this.sensorlist = result.data;
        // console.log(this.sensorlist)
        this.action.forEach((element, j) => {
          element.con.forEach((consen, i) => {
            this.sensorlist.forEach((sensor) => {
              if (sensor.id == consen.sensid) {
                consen.sensid = sensor.name;
              }
            });
          });
        });
      });
      element.action = temp;
      temp = [];
    });
    // console.log(this.realaction)
  },
  mounted() {
    switch (this.userAccount || this.admin) {
      case "betagrodemo":
        var elem = document.getElementsByClassName("con-vs-card");
        Array.prototype.filter.call(elem, function (testElement) {
          testElement.style.background = "#212121";
        });
        var elemtable = document.getElementsByClassName("vs-con-table");
        Array.prototype.filter.call(elemtable, function (testElementtable) {
          testElementtable.style.background = "#212121";
        });
        var elemtableheader =
          document.getElementsByClassName("vs-table--header");
        Array.prototype.filter.call(
          elemtableheader,
          function (testElementtableheader) {
            testElementtableheader.style.background = "#212121";
          }
        );
        var elemtableul = document.getElementsByClassName("vs-pagination--ul");
        Array.prototype.filter.call(elemtableul, function (testElementtableul) {
          testElementtableul.style.background = "none";
        });

        break;
      default:
        console.log("Try looking up for a hint.");
    }
  },
};
</script>

<style>
a {
  cursor: pointer;
}
.vs-table--not-data {
  font-size: 0%;
}
</style>
<style scoped>
#noWrap {
  padding: 0px;
  white-space: nowrap;
  font-size: 0.75rem;
}
#btncancel {
  background-color: #ffffff;
  border-radius: 0;
  border-color: #ffffff;
}
.vs-button {
  border-radius: 20px;
}
span {
  text-transform: none;
}
</style>